import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth, userCan } from './AuthContext'
import { useToast } from '@/components/layout/Toast'

/**
 * Route guard for the revenue surface (/reports). A member without the
 * `canViewReports` permission (#572) can't reach it — the palette already
 * hides the entry; this stops direct-URL access too. The server still refuses
 * the data (`GET /invoices/report-summary` is capability-gated) regardless.
 * Owners/legacy sessions pass. Blocked members land on Home with a one-line
 * explanation — never on a dead end.
 */
export function RequireViewReports({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  const { addToast } = useToast()
  const blocked = !userCan(user, 'canViewReports')
  useEffect(() => {
    if (blocked) addToast('info', 'Reports are available to teammates with the View reports permission', 'reports-gate')
  }, [blocked, addToast])
  if (blocked) {
    return <Navigate to="/home" replace />
  }
  return <>{children}</>
}
